import { motion } from "framer-motion";
import { Zap } from "lucide-react";

const links = [
  { id: "skill", label: "Skill" },
  { id: "timeline", label: "Timeline" },
  { id: "rules", label: "Rules" },
  { id: "judging", label: "Judging" },
  { id: "prizes", label: "Prizes" },
];

export default function Navbar() {
  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl"
      data-testid="navbar"
    >
      <div className="glass rounded-full pl-3 pr-1.5 md:pl-4 md:pr-2 py-2 flex items-center justify-between gap-2 overflow-hidden">
        <a href="#top" className="flex items-center gap-2 group shrink-0" data-testid="nav-logo">
          <div className="relative">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#2FCC7C] to-[#2D7BF0] flex items-center justify-center">
              <Zap className="w-4 h-4 text-black" strokeWidth={2.5} />
            </div>
            <div className="absolute inset-0 rounded-lg bg-[#2FCC7C]/50 blur-md opacity-60 group-hover:opacity-100 transition-opacity" />
          </div>
          <span className="font-heading font-bold text-sm tracking-tight hidden md:block">
            CareStack<span className="text-[#2FCC7C]">.</span>AI
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-0.5 shrink">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="px-2.5 py-1.5 text-[10px] font-mono uppercase tracking-[0.15em] text-zinc-400 hover:text-white transition-colors rounded-full hover:bg-white/5 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="https://forms.gle/6mgpbxdarhwd52Uo7"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-register-btn"
          className="text-[10px] md:text-xs font-mono uppercase tracking-widest px-3 md:px-4 py-2 rounded-full bg-[#2FCC7C] text-black font-bold hover:shadow-[0_0_20px_rgba(47,204,124,0.6)] transition-shadow whitespace-nowrap shrink-0"
        >
          Register
        </a>
      </div>
    </motion.header>
  );
}
